module.exports = __webpack_public_path__ + "media/images/front/pc/routable/icon_merit-190afb56d14a6f15a8adf20fa502c15b.svg";